<button
  type="button"
  class="btn multiselect-btn"
  (click)="toggle()"
  [disabled]="disabled"
  #toggleButton
>
  {{ buttonLabel }}
</button>
<div class="dropdown">
  <ul
    class="dropdown-menu multi_select_list_dropdown_menu"
    [class.show]="isOpen"
    #list
  >
    <li
      class="d-flex w-100"
      [ngClass]="
        !quotaFlags.census && quotaFlags.delete
          ? 'justify-content-between quota-btn-width'
          : ''
      "
    >
      <a
        *ngIf="quotaFlags.add"
        class="quota-btn"
        (click)="openMultiselectInputQuotaModal()"
        [ngClass]="{
          'btn-disabled': isAdvanceTargetingParent || isQlcLiveSurvey
        }"
      >
        Add Quotas
      </a>
      <a
        *ngIf="quotaFlags.edit"
        class="quota-btn"
        (click)="openMultiselectInputQuotaModal()"
        [ngClass]="{
          'btn-disabled': isEditQuotaDisabled,
          'children-info': showChildrenTooltip
        }"
      >
        Edit Quota
      </a>
      <div class="setting-info age-child-info" *ngIf="showChildrenTooltip">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        <p style="white-space: normal">
          You can set Age/Gender quotas by editing children quotas
        </p>
      </div>
      <a
        *ngIf="quotaFlags.census"
        class="quota-btn"
        (click)="checkAndApplyMultiselectInputCensus()"
        [ngClass]="{
          'btn-disabled':
            disableCensusBtn || isAdvanceTargetingParent || isQlcLiveSurvey
        }"
      >
        Census
      </a>
      <a
        *ngIf="quotaFlags.delete"
        class="quota-btn"
        (click)="deleteMultiselectInputQuotas()"
        [ngClass]="{ 'btn-disabled': isQlcLiveSurvey }"
      >
        Delete Quotas
      </a>
    </li>
    <li>
      <label class="table-desc" for="all_checked_{{ id }}">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="parentSelector"
          [value]="-1"
          [disabled]="!!isAdvanceTargetingParent"
          (change)="onSelectChange($event)"
          id="all_checked_{{ id }}"
        />
        <span>{{ parentSelectorLabel }}</span>
      </label>
    </li>
    <li class="my-2 border-color-gray"></li>
    <li
      *ngFor="let item of qualification.data; let i = index"
      [attr.data-index]="i"
    >
      <label class="table-desc" for="single-items-checked_{{ id }}_{{ i }}">
        <input
          class="form-check-input"
          type="checkbox"
          [value]="item.id"
          [checked]="item.selected"
          [(ngModel)]="item.selected"
          [disabled]="!!isAdvanceTargetingParent"
          (change)="onSelectChange($event)"
          id="single-items-checked_{{ id }}_{{ i }}"
        />
        <span>{{ item.text }}</span>
      </label>
    </li>
  </ul>
</div>
